import { createAction, props } from "@ngrx/store";
import {Role, RolePermission, SituazioneRuoli} from "@modules/roles/roles.interface";

/* load all roles */
export const RoleLoadAllAction = createAction(
  "[Roles Resolver] Load All Roles"
);

export const RoleLoadedAllAction = createAction(
  "[Load Roles Effect] All Roles Loaded",
  props<{ situazioneRuoli: SituazioneRuoli }>()
);

export const RoleErrorLoadingAction = createAction(
  "[Load Roles Effect] Error Loading Roles"
);

/* add role */
export const RoleAddAction = createAction(
  '[Roles] add',
  props<{ role: Partial<Role> }>()
);

export const RoleAddedAction = createAction(
  '[Roles] added',
  props<{ ruolo: Role }>()
);

export const RoleErrorAddingAction = createAction(
  '[Roles] Error Adding Role'
);

/* delete role */
export const RoleDeleteAction = createAction(
  '[Roles] delete',
  props<{ id: string }>()
);

export const RoleDeletedAction = createAction(
  '[Roles] deleted',
  props<{ id: string }>()
);

export const RoleErrorDeletingAction = createAction(
  '[Roles] Error Deleting Role'
);

/* update role */
export const RoleUpdateAction = createAction(
  '[Roles] update role',
  props<{ role: Role }>()
);

export const RoleUpdatedAction = createAction(
  '[Roles] role updated',
  props<{ role: Partial<Role> }>()
);

export const RoleErrorUpdatingAction = createAction(
  '[Roles]: Error Updating Role'
);

/* add permission to role */
export const RoleAddPermissionAction = createAction(
  '[Roles] add permission to role',
  props<{ permissionToRole: Role }>()
);

export const RolePermissionAddedAction = createAction(
  '[Roles] permission to role added',
  props<{ permissionToRole: RolePermission }>()
);

export const RoleErrorAddingPermissionAction = createAction(
  '[Roles] Error Adding Permission To Role'
);

/* remove permission from role */
export const RoleRemovePermissionAction = createAction(
  '[Roles] remove permission from role',
  props<{ permissionFromRole: Role }>()
);

export const RolePermissionRemovedAction = createAction(
  '[Roles] permission from role removed',
  props<{ permissionFromRole: Role }>()
);

export const RoleErrorRemovingPermissionAction = createAction(
  '[Roles] Error Removing Permission From Role'
);
